/**
 * 
 * 
 * 体系图
 * 
 * 
 */
import { unique, formatText } from "../js/common.js"
function Paresetixitu(tables) {
  let headerData = []
  for (let i = 1; i <= tables.Rows.Count; i++) {
    let cells = tables.Rows.Item(i).Cells
    if (i == 1) {
      //处理头
      for (let j = 1; j <= cells.Count; j++) {
        var text = cells.Item(j).Value()
        if (!text) {
          headerData.push(headerData[j - 2] + "_sub")
        } else {
          headerData.push(text)
        }
      }
    }
  }
  console.log('表头', headerData)

  let tabelsData = []

  //跑一下数据  补充以下合并导致的数据值读不到
  for (let i = 2; i <= tables.Rows.Count; i++) {
    var tableData = {}
    let cells = tables.Rows.Item(i).Cells
    for (let j = 1; j <= cells.Count; j++) {
      let text = cells.Item(j).Value()
      var headerText = headerData[j - 1]
      if (!text) {
        if (j == 1) {
          if (tabelsData.length > 0) {
            text = tabelsData[tabelsData.length - 1][headerText]
          } else {
            text = tableData[headerData[j - 2]]
          }
        }

        if (j > 1) {
          if (tabelsData.length > 0 && tableData[headerData[j - 2]] == tabelsData[tabelsData.length - 1][headerData[j - 2]]) {
            text = tabelsData[tabelsData.length - 1][headerText]
          } else {
            text = tableData[headerData[j - 2]]
          }
        }
      }
      if (text === '/') {
        text = ""
        continue
      }
      tableData[headerText] = text
    }
    tabelsData.push(tableData)
  }
  console.log(JSON.parse(JSON.stringify(tabelsData)))


  var tranfarmTableData = []
  //头不存在措施分类的
  if (headerData.indexOf('措施分类') > 0) {
    for (let index = 0; index < tabelsData.length; index++) {
      var item = tabelsData[index]
      var findIndex = tranfarmTableData.findIndex((item1) => item1[headerData[0]] === item[headerData[0]] && item1[headerData[0] + "_sub"] === item[headerData[0] + "_sub"])
      var newValue = ""
      var caKey = item["措施分类"]
      if (findIndex != -1) {
        var mergeItem = tranfarmTableData[findIndex]
        Object.keys(item).forEach((key) => {
          if (key != headerData[0] && key != headerData[0] + "_sub" && key != "措施分类") {
            if (item[key]) {
              if (newValue === "") {
                newValue = item[key]
              } else {
                newValue += "、" + item[key]
              }
            }
          }
        })
        mergeItem[caKey] = newValue
      } else {
        var newTableDataItem = {}
        newTableDataItem[headerData[0]] = item[headerData[0]]
        newTableDataItem[headerData[0] + "_sub"] = item[headerData[0] + "_sub"]
        Object.keys(item).forEach((key) => {
          if (key != headerData[0] && key != headerData[0] + "_sub" && key != "措施分类") {
            if (item[key]) {
              if (newValue === "") {
                newValue = item[key]
              } else {
                newValue += "、" + item[key]
              }
            }
          }
        })
        console.log(caKey, newValue)
        newTableDataItem[caKey] = newValue
        tranfarmTableData.push(newTableDataItem)
      }
    }
    tabelsData = tranfarmTableData
  }
  console.log(JSON.parse(JSON.stringify(tabelsData)))
  console.log(headerData)


  var groupTableDate = []
  //分下组
  var titleList = tabelsData.map((item) => item[headerData[0]])
  titleList = unique(titleList)
  console.log(titleList)
  titleList.forEach((title) => {
    var findList = tabelsData.filter((item2) => item2[headerData[0]] === title)
    if (findList.length == 1) {
      var count = 0;
      findList.forEach(item => {
        delete item[headerData[0]]
        delete item[headerData[0] + "_sub"]
        count += Object.keys(item).length
      })
      groupTableDate.push({
        "value": title,
        "data": findList,
        "count": count
      })
    } else {
      var subItemList = []
      findList.forEach(item => {
        var subKey = item[headerData[0] + "_sub"]
        delete item[headerData[0]]
        delete item[headerData[0] + "_sub"]
        subItemList.push({
          "value": subKey,
          "data": item,
          "count": Object.keys(item).length
        })
      })
      if (subItemList.length > 0) {
        let total = subItemList.reduce((prev, item) => {
          prev += item.count
          return prev
        }, 0)
        groupTableDate.push({
          "value": title,
          "data": subItemList,
          "count": total
        })
      }
    }
  })
  tabelsData = groupTableDate
  console.log(groupTableDate)
  window.Application.PluginStorage.setItem('type', "tixi")
  window.Application.PluginStorage.setItem('tabelsData', JSON.stringify(tabelsData))
}



export default {
  Paresetixitu,
}
